import React from "react";
import styled from "styled-components";
import { fetchAPI } from "../../../utils/fetch";
import { config } from "../../../utils/config";
import { useState, useEffect } from "react";
import PostsMainPage from "./PostsMainPage";
import Plans from "../../../components/plans";
import { useGetStoredData } from "../../../hooks/useGetStoreData";

const Posts = () => {
  const [pageLoading, setPageLoading] = useState(false);
  const [showPostsPage, setShowPostsPage] = useState(false);
  const [remainingTime, setRemainingTime] = useState(null);
  const [showUpgradeWarning, setShowUpgradeWarning] = useState(false);
  const [showTrialEndedModal, setShowTrialEndedModal] = useState(false);
  const [trialEnded, setTrialEnded] = useState(false);
  const [showTestNote, setShowTestNote] = useState(false);
  const [showReconnectButton, setShowReconnectButton] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isConnectButtonDisabled, setisConnectButtonDisabled] = useState(false);
  const [errorMessage, seterrorMessage] = useState(null);

  const storedData = useGetStoredData();
  // console.log('STOREDDATA', storedData);
  // Helper: start countdown
  const updateCountdown = (expiresAtTimestamp) => {
    const expiresAt = new Date(expiresAtTimestamp * 1000); // Convert Firestore timestamp
    // to Date
    const interval = setInterval(() => {
      const now = new Date();
      const diffMs = expiresAt - now;

      if (diffMs <= 0) {
        clearInterval(interval);
        setRemainingTime("00:00:00");
        setShowUpgradeWarning(false);
        setShowTrialEndedModal(true);
        setShowPostsPage(false); // Optional: restrict access
        seterrorMessage("Trial Expired");
      } else {
        const diffSec = Math.floor(diffMs / 1000);
        const hours = String(Math.floor(diffSec / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((diffSec % 3600) / 60)).padStart(
          2,
          "0"
        );
        const seconds = String(diffSec % 60).padStart(2, "0");

        setRemainingTime(`${hours}:${minutes}:${seconds}`);

        // Show warning if 5 minutes or less
        setShowUpgradeWarning(diffSec <= 300);
      }
    }, 1000);
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setPageLoading(true);

        const response = await fetchAPI.get(
          `${config.urlPlatform}/api/v2/unipile/auth/getUserProfile`,
          {
            withCredentials: true,
            validateStatus: () => true, // ✅ prevents auto-throw on 400/500
          }
        );
        // console.log("RESPONSE", response);
        if (response.data.success) {
          // console.log("qDATA RESP", response);
          const profileSuccess = response?.data?.success;
          const queueData = response?.data?.data?.userQueueData;
          // console.log("qDATA", queueData);
          
          if (!profileSuccess) return;

          if(queueData) {
            // Case: Trial queue user whose trial has ended
            if (queueData?.status === "trialExpired") {
              setShowTrialEndedModal(true);
              setTrialEnded(true);
              setisConnectButtonDisabled(true);
              return;
            }
  
            // Extract common values
            // const isTrialing = queueData?.paidStatus === "trialing";
            const isActive = queueData?.status === "active";
            const hasExpiresAt = !!queueData?.expiresAt?._seconds;
            const hasAccountId = !!queueData?.account_id;
  
            // Case: Trial user in queue can use feature (LinkedIn connected)
            if (isActive && hasAccountId && hasExpiresAt) {
              setShowTestNote(true);
              setShowPostsPage(true);
              updateCountdown(queueData.expiresAt._seconds);
              return;
            }
          } else {
            // Case: All other users with successful profile (e.g., proMonth, proMonth_yearly)
            setShowPostsPage(true);
          }
        } else if (!response.data.success) {
          // console.log('resppppp ', response.data)
          const isUserNotFound = response.data.event === "EXISTING_UNIPILE_USER_NOT_FOUND";
          const { plan, paidStatus, sevenDayTrial, queueStatus } = response.data.data;
          // console.log('QUEYE', queueStatus)
          const isPaidInfluencerPlan = (plan === "proMonth" || plan === "proMonth_yearly") && paidStatus === true;
          const isSevenDayTrialActive = sevenDayTrial === true;
          const isTrialExpired = queueStatus === "trialExpired";
          const isOtherPlan = !isPaidInfluencerPlan && !isSevenDayTrialActive;

          //Influencer plan
          if (isUserNotFound && isPaidInfluencerPlan && !isSevenDayTrialActive) {
            setShowPostsPage(false);
          }
          
          if (isUserNotFound && isSevenDayTrialActive && !isTrialExpired) {
            setShowTestNote(true);
            setShowPostsPage(false);
          }

          // Case: New trial user in queue (no LinkedIn account connected)
          if (isUserNotFound && isOtherPlan && !isTrialExpired) {
            setShowTrialEndedModal(true);
            setTrialEnded(true);
            setisConnectButtonDisabled(true);
            return;
          }

          if (isUserNotFound && isTrialExpired && (plan !== "proMonth" && plan !== "proMonth_yearly")) {
            setShowTrialEndedModal(true);
            setTrialEnded(true);
            setisConnectButtonDisabled(true);
            return;
          }

          // Case: New trial user in queue (no LinkedIn account connected)
          if (response.data.event === "EXISTING_DELETED_UNIPILE_USER") {
            const userData = response?.data?.data;
            if (userData?.last_deleted_unipile_account) {
              setShowReconnectButton(true);
              seterrorMessage(
                "Your session has expired due to 30+ hours of inactivity. This helps us keep the system fast and affordable for everyone. Please reconnect to continue."
              );
            }
            return;
          }
        }
      } catch (error) {
        console.log("Error getting profile", error);
        setShowPostsPage(false);
      } finally {
        setPageLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  const handleConnectClick = async () => {
    try {
      setisConnectButtonDisabled(true);
      seterrorMessage(null);

      const response = await fetchAPI.get(
        `${config.urlPlatform}/api/v2/unipile/auth/wizard/connectLinkedin`,
        { withCredentials: true }
      );
      // console.log("RESPONSE 1111", response);
      if (response?.data?.success) {
        const { data } = response;
        if (data?.data === "waiting") {
          seterrorMessage(data?.message);
        } else if (data?.data?.object === "HostedAuthUrl") {
          window.location.assign(data?.data?.url);
        } else {
          setShowPostsPage(true);
        }
      }

      if(!response.data.success) {
        seterrorMessage(response?.data?.message);
      }
    } catch (error) {
      // console.log("ERROR", error);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Error connecting to LinkedIn";
      seterrorMessage(message);
    } finally {
      const timer = setTimeout(() => {
        setisConnectButtonDisabled(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  };

  if (pageLoading) {
    return (
      <Container>
        <PageLoader />
      </Container>
    );
  }

  return (
    <div style={{ overflow: "auto" , height:"calc(100dvh - 84px)"}}>
      {!showPostsPage ? (
        <Container>
          <div style={{height:"100%"}}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center", // vertical center
                alignItems: "center", // horizontal center
                // height: "100vh", // take full screen height
                gap: "16px", // space between buttons
              }}
            >
              <div>
                <ConnectButton
                  onClick={handleConnectClick}
                  disabled={isConnectButtonDisabled}
                  style={{
                    opacity: isConnectButtonDisabled ? 0.5 : 1,
                    cursor: isConnectButtonDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  {showReconnectButton
                    ? "Reconnect Now"
                    : isConnectButtonDisabled && trialEnded
                    ? "Connect your LinkedIn account"
                    : isConnectButtonDisabled
                    ? "Connecting..."
                    : "Connect your LinkedIn account"}
                </ConnectButton>
              </div>

              {trialEnded && (
                <div>
                  <ConnectButton onClick={() => setOpenModal(true)}>
                    Subscribe Now
                  </ConnectButton>
                </div>
              )}
            </div>

            <div>
              {errorMessage && (
                <ErrorMessage style={CenterStyle}>{errorMessage}</ErrorMessage>
              )}
            </div>
            <YouTubeContainer >
              <iframe
                style={{border:"0px solid #000"}}
                width="560"
                height="315"
                src="https://www.youtube.com/embed/SExWS84klkg"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </YouTubeContainer>

            {showTestNote && (
              <div
              style={{
                backgroundColor: "#FFFBEA",
                borderLeft: "5px solid rgb(21, 120, 250)",
                padding: "16px",
                borderRadius: "16px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                maxWidth: "800px",
                margin: "20px auto 0",
              }}
            >
              <h1
                style={{
                  fontSize: "15px",
                  fontWeight: 600,
                  color: "#92400E",
                  lineHeight: 1.6,
                  margin: "0px",
                }}
              >
                  You have{" "}
                  <span
                    style={{ textDecoration: "underline", fontWeight: "bold" }}
                  >
                    ONE
                  </span>{" "}
                  chance to test this feature for free. Your session will last{" "}
                  <span style={{ fontWeight: "bold" }}>30 minutes</span>, after
                  that you’ll need to upgrade to continue.
                </h1>
              </div>
            )}
          </div>
          <>
            {showTrialEndedModal && !openModal && (
              <>
                <TrialEndedOverlay>
                  <TrialEndedModalBox>
                    <h2>⏳ Your Free Trial Has Ended/Upgrade to Influencer plan</h2>
                    <p>
                      Your session is over, but your data is saved!
                      <br />
                      To keep using this feature, please upgrade.
                    </p>
                    <div className="button-group">
                      <button
                        className="upgrade-btn"
                        onClick={() => {
                          setOpenModal(true);
                        }}
                      >
                        Upgrade Now
                      </button>
                      <button
                        className="close-btn"
                        onClick={() => setShowTrialEndedModal(false)}
                      >
                        Close
                      </button>
                    </div>
                  </TrialEndedModalBox>
                </TrialEndedOverlay>
              </>
            )}
            {openModal && <Plans setOpenModal={setOpenModal} unipile={true}/>}
          </>
        </Container>
      ) : (
        <PostsMainPage
          remainingTime={remainingTime}
          showUpgradeWarning={showUpgradeWarning}
          showTrialEndedModal={showTrialEndedModal}
          setShowTrialEndedModal={setShowTrialEndedModal}
        />
      )}
    </div>
  );
};

const TrialEndedOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const TrialEndedModalBox = styled.div`
  background: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  text-align: center;
  max-width: 400px;
  font-size: 0.85rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  h2 {
    font-size: 1.1rem;
    margin-bottom: 0.75rem;
  }

  p {
    margin: 0;
    color: #333;
  }

  .button-group {
    margin-top: 1.5rem;
    display: flex;
    justify-content: center;
    gap: 0.75rem;
  }

  button {
    padding: 8px 16px;
    border-radius: 6px;
    font-weight: bold;
    font-size: 0.75rem;
    cursor: pointer;
    border: none;
  }

  .upgrade-btn {
    background-color: #007bff;
    color: #fff;
  }

  .close-btn {
    background-color: #e0e0e0;
    color: #333;
  }
`;

const YouTubeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 60px;
`;

const CenterStyle = {
  display: "flex",
  "justify-content": "center",
  "align-items": "center",
};

const Container = styled.div`
  // display: flex;
  // justify-content: center;
  // align-items: center;
  height: 100%;
`;

const ConnectButton = styled.button`
  text-align: center;
  background-color: #0a66c2;
  cursor: pointer;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  margin-top:30px;
`;

const ErrorMessage = styled.div`
  color: red;
  font-weight: 600;
  margin-bottom: 2rem;
  animation: fade-up-quick 0.5s;
`;

export const PageLoader = styled.span`
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  position: relative;
  animation: rotate 1s linear infinite;
  &::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 4px solid #0a66c2;
    animation: prixClipFix 2s linear infinite;
  }
`;

export default Posts;
